"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";

const navItems = [
  { href: "/memory",   label: "Memory",   emoji: "🧠" },
  { href: "/projects", label: "Projects", emoji: "📋" },
  { href: "/calendar", label: "Calendar", emoji: "📅" },
  { href: "/costs",    label: "Costs",    emoji: "💰" },
];

export default function Sidebar() {
  const pathname = usePathname();
  const [collapsed, setCollapsed] = useState(false);

  const now = new Date();
  const timeStr = now.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/Chicago",
  });

  return (
    <aside className={`${collapsed ? "w-[74px]" : "w-[220px]"} flex-shrink-0 flex flex-col py-6 border-r border-[#e4ddd0] bg-[#f2ede4] transition-[width] duration-200`}>
      {/* Brand */}
      <div className={`${collapsed ? "px-3 pb-4" : "px-7 pb-5"} border-b border-[#e4ddd0] mb-4`}>
        <div className={`flex items-start ${collapsed ? "justify-center" : "justify-between gap-3"}`}>
          <div className={collapsed ? "sr-only" : ""}>
            <span className="text-3xl block mb-2">🤖</span>
            <div
              className="text-xs tracking-[0.15em] uppercase text-[#8a7a68]"
              style={{ fontFamily: "Georgia, serif" }}
            >
              Mission Control
            </div>
            <div className="text-[11px] text-[#b0a090] mt-1 italic">
              Robby · Austin, TX
            </div>
          </div>
          {collapsed && <span className="text-2xl block">🤖</span>}
        </div>
        <div className={collapsed ? "mt-4 flex justify-center" : "mt-5"}>
          <button
            onClick={() => setCollapsed(!collapsed)}
            className={`${collapsed ? "w-10 h-9 justify-center" : "w-full justify-between px-3"} flex items-center rounded-md border border-[#ded6c8] bg-[#faf8f4] py-2 text-[12px] font-medium text-[#6b5c48] shadow-sm hover:border-[#c9bca9] hover:text-[#b5622a] hover:bg-[#fdf7f0] transition-colors`}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {!collapsed && <span>Collapse</span>}
            <span className="text-[15px] leading-none">{collapsed ? "›" : "‹"}</span>
          </button>
        </div>
      </div>

      {/* Nav */}
      <nav className={`flex flex-col gap-0.5 ${collapsed ? "px-2" : "px-3"}`}>
        {navItems.map((item) => {
          const isActive = pathname === item.href || pathname.startsWith(item.href + "/");
          return (
            <Link
              key={item.href}
              href={item.href}
              title={item.label}
              className={`flex items-center ${collapsed ? "justify-center px-0" : "gap-3 px-4"} py-2.5 rounded-sm text-sm transition-all
                border-l-[3px]
                ${isActive
                  ? "text-[#b5622a] border-[#b5622a] bg-[#fdf7f0] font-semibold"
                  : "text-[#6b5c48] border-transparent hover:bg-[#ece7dc] hover:text-[#2c2416]"
                }`}
            >
              <span className="text-base">{item.emoji}</span>
              {!collapsed && <span>{item.label}</span>}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className={`${collapsed ? "px-2 text-center" : "px-7"} mt-auto pt-6 text-[11px] text-[#b0a090] italic leading-relaxed`}>
        Last updated<br />
        {collapsed ? timeStr : `today at ${timeStr}`}
      </div>
    </aside>
  );
}
